import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import Style from './style.js';
import HelperTransition from '../../utils/helperTransition/index.js';
import formatMessage from './formatMessage/index.js';
import { jsx } from '@emotion/react';

var VerificationMessages = _ref => {
  var {
    centered = false,
    inputId,
    messages = {},
    type = 'error'
  } = _ref;
  var messageKeys = Object.keys(messages);
  var showMessages = messageKeys.length > 0;
  return jsx(TransitionGroup, {
    component: centered ? Style.CenteredMessageList : Style.MessageList
  }, showMessages ? messageKeys.filter(key => {
    var message = messages[key];

    if (!Array.isArray(message)) {
      return true;
    }

    return message.length > 0;
  }).map(key => jsx(HelperTransition, {
    key: key
  }, jsx(Style.MessageItem, {
    type: type
  }, jsx("output", {
    htmlFor: inputId,
    role: "alert"
  }, formatMessage(messages[key]))))) : // eslint-disable-next-line react/jsx-no-useless-fragment -- TransitionGroup type compatibility
  jsx(React.Fragment, null));
};

export { VerificationMessages };
